import { Modal, Descriptions, Spin } from 'antd';
import moment from 'moment';
import type { Study } from '@/models/study';
import { formatStudyDateTime } from '@/shared/utils/studyDate';
import styles from './StudyInfoModal.module.css';

interface StudyInfoModalProps {
  open: boolean;
  onClose: () => void;
  study?: Study;
  loading: boolean;
}

export default function StudyInfoModal({
  open,
  onClose,
  study,
  loading,
}: StudyInfoModalProps) {
  const patient =
    study?.patientFirstName && study?.patientLastName
      ? `${study.patientFirstName} ${study.patientLastName}`
      : '—';

  return (
    <Modal
      title="Study Information"
      open={open}
      onCancel={(e) => {
        e.stopPropagation();
        onClose();
      }}
      footer={null}
      width={600}
    >
      {loading || !study ? (
        <Spin className={styles.spinner} />
      ) : (
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Study ID">{study.icid}</Descriptions.Item>
          <Descriptions.Item label="Modality">
            {study.modality}
          </Descriptions.Item>
          <Descriptions.Item label="Patient">{patient}</Descriptions.Item>
          <Descriptions.Item label="MRN">
            {study.patientMedicalRecordNumber}
          </Descriptions.Item>
          <Descriptions.Item label="Study Date">
            {formatStudyDateTime(study.studyDate)}
          </Descriptions.Item>
          <Descriptions.Item label="Created">
            {moment(study.createdAt).format('MMM D, YYYY h:mm A')}
          </Descriptions.Item>
          <Descriptions.Item label="Updated">
            {moment(study.updatedAt).format('MMM D, YYYY h:mm A')}
          </Descriptions.Item>
          <Descriptions.Item label="DICOM Count" span={2}>
            {study.dicoms?.length ?? 0}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
}
